import httpClient from "../httpClient"
import { formatData } from "../request"
import { encodeRequestParameters } from "../request"

import { flyerTemplatesFormat } from "../formats"
export function getFlyers(residenceId, data, config) {
    return httpClient
        .post(`/flyers/residence/${residenceId}`, data, config)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export function getTemplates(data) {
    data = formatData(flyerTemplatesFormat, data)
    const params = encodeRequestParameters(data)

    return httpClient
        .get(`/flyers/templates`, { params })
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}